import React from 'react';
import { useTranslation } from 'react-i18next';

import MultiDigitInput from '../../shared/MultiDigitInput';
import NextButton from '../../shared/NextButton';

import './Step2.scss';

function Step2({ callback, cancelCallback, disabled }) {
    const [t] = useTranslation();
    const [verificationCode, setVerificationCode] = React.useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        callback(verificationCode);
    };

    return (
        <div
            id="form-forgot-password-verify"
            role="main"
        >
            <form onSubmit={handleSubmit}>
                <h2>{t('Authentication.ForgotPasswordPage.EnterVerificationCode')}</h2>
                <p>{t('Authentication.ForgotPasswordPage.VerificationCodeInstructions')}</p>
                <MultiDigitInput
                    digits="6"
                    value={verificationCode}
                    onChange={setVerificationCode}
                    label={t('Authentication.ForgotPasswordPage.VerificationCode')}
                    autofocus={true}
                    disabled={disabled}
                />
                <NextButton
                    action={handleSubmit}
                    disabled={disabled || verificationCode.length < 6}
                >
                    {t('Authentication.ForgotPasswordPage.VerificationCodeSubmit')}
                </NextButton>
                <div id="no-receive">
                    {t('Authentication.ForgotPasswordPage.VerificationCodeNoReceive')}{' '}
                    <button
                        className="button-link"
                        onClick={cancelCallback}
                    >
                        {t('Authentication.ForgotPasswordPage.VerificationCodeResend')}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default Step2;
